import React from "react";
import {
  Container,
  IntroBox,
  IntroLeft,
  IntroRight,
  SocialIconsRow,
  SocialIcon,
} from "./intro_elements";
import { Fade } from "react-reveal";
import PrimaryButton from "../../common/PrimaryButton";
import { introSection } from "../../data";
const Intro = () => {
  return (
    <Container>
      <IntroBox>
        <IntroLeft>
          <Fade bottom duration={1000}>
            <h1>{introSection.heading}</h1>
            <h2
              style={{
                fontSize: "1.5rem",
              }}
            >
              {introSection.description}
            </h2>
            <SocialIconsRow>
              {introSection.contact.map((contact, i) => {
                return (
                  <SocialIcon key={i} href={contact.url} target="_blank">
                    <img
                      src={require("../../assets/images/" + contact.icon)}
                      alt={contact.url}
                    ></img>
                  </SocialIcon>
                );
              })}
            </SocialIconsRow>

            <SocialIconsRow>
              <PrimaryButton text="Contact me" href="#contact" />

              <PrimaryButton
                text="See my resume"
                href={introSection.resume}
                newTab={true}
              />
            </SocialIconsRow>
          </Fade>
        </IntroLeft>

        <IntroRight>
          <Fade zoom duration={5000}>
            <img
              src={require("../../assets/images/" + introSection.mypic)}
              alt="Safwan Mamji"
            ></img>
          </Fade>
        </IntroRight>
      </IntroBox>
    </Container>
  );
};

export default Intro;
